<li class="nav-item">
    <button class="btn btn-dark text-white me-2" (click)="openKindModal()"><i class="fa fa-exchange" aria-hidden="true"></i> {{ "changeAtype" | language }}</button>
</li>
<app-kindsmodal [id]="'atypesListModal'"></app-kindsmodal>
